import React, { useState, useEffect, useContext } from "react";

import db from "../../../services/query";
import lbl from "../../../data/Labels.json";

import { HalfYearContext } from "../../../contexts/halfYearContext";
import { PopUpContext } from "../../../contexts/popUpContext";

import ExpenseSubAccountsList from "./ExpenseSubAccountsList";
import TableMainSearch from "../../common/MainSearch";
import MainButton from "../../common/MainButton";
import MainTitle from "../../common/MainTitle";
import MainPrintLink from "../../common/MainPrint";
import { isFinanceReadOnly } from "../../../utils/financeAccess";

const ExpenseSubAccounts = (props) => {
  const [data, setData] = useState([]);
  const [query, setQuery] = useState("");

  const { halfYear } = useContext(HalfYearContext);
  const { togglePopUp, popUp } = useContext(PopUpContext);

  const { tid, aid } = props.match.params;

  useEffect(() => {
    const ac = new AbortController();

    requestData({ halfYear });

    return () => ac.abort();
  }, [halfYear, popUp]);

  const requestData = async (p = new Object()) => {
    try {
      const { halfYear } = p;

      let query = `expenses/types/${tid}/accounts/${aid}/subAccounts?halfYearId=${halfYear}`;

      await db.getAll(query).then(({ data }) => {
        setData(data);
      });
    } catch ({ response }) {
      setData(response);
    }
  };

  return (
    <div className="main-content">
      <div className="main-content-header">
        <div className="right-content">
          <MainButton title={lbl.PrevPage} type={"back"} />
          <MainTitle title={data?.summary?.title} />
        </div>
        <div className="center-content">
          <TableMainSearch setQuery={setQuery} />
        </div>
        <div className="left-content">
          {!isFinanceReadOnly() && (
          <MainButton
            title={lbl.CreateSubAccount}
            handleClick={() =>
              togglePopUp({ form: "expense-sub-account-form", type: aid })
            }
            type={"add"}
          />
          )}
          <MainPrintLink path={`expenses/type/${tid}/account/${aid}/halfYear/${halfYear}`} />
        </div>
      </div>
      <div className="main-content-body">
        <ExpenseSubAccountsList
          data={data}
          {...props}
          query={query}
          halfYear={halfYear}
        />
      </div>
    </div>
  );
};

export default ExpenseSubAccounts;
